<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="4">
        <v-card>
          <v-progress-linear v-model="progress" color="primary" height="25">
            <template v-slot:default="{ value }">
              <strong>{{ progress }}%</strong>
            </template></v-progress-linear
          >
          <v-card-title>
            {{ project.name }}
          </v-card-title>
          <v-card-subtitle align="left">
            <span class="text-primary">
              Created by {{ project.creator }} on {{ project.date }}
            </span>
            <br />
            {{ project.description }}
          </v-card-subtitle>
          <v-card-text align="left">
            <v-row>
              <v-col cols="5">
                <strong> Project Manager </strong>
                <div>{{ project.creator }}</div>
                <br />
                <strong> Deadline </strong>
                <div>{{ project.completionDate }}</div>
              </v-col>
              <v-col cols="7">
                <div style="text-align: end">
                  <strong>Budget</strong>
                  <h2 class="text-primary">$ {{ project.budget }}</h2>
                </div>
                <br />
                <div style="text-align: end">
                  <strong>Spent So Far</strong>
                  <h2 class="text-accent">$ 0</h2>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="primary"> Invite </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" lg="4">
        <v-card>
          <v-btn
            fab
            color="primary"
            @click="tasksDialog = true"
            absolute
            top
            right
          >
            <v-icon>add</v-icon>
          </v-btn>
          <v-card-title> Tasks </v-card-title>
          <v-card-text>
            <v-checkbox
              label="Request estimates from at least 3 different companies"
              color="accent"
              input-value="true"
              value
              hide-details
            ></v-checkbox>
            <v-checkbox
              label="Schedule board meeting to go over estimates"
              color="accent"
              value
              hide-details
            ></v-checkbox>
            <v-checkbox
              label="Submit plans to ACC"
              color="accent"
              value
              hide-details
            ></v-checkbox>
          </v-card-text>
        </v-card>
        <br />
        <v-card>
          <v-btn
            fab
            color="primary"
            @click="tasksDialog = true"
            absolute
            top
            right
          >
            <v-icon>add</v-icon>
          </v-btn>
          <v-card-title>Notes</v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" lg="4">
        <v-card>
          <v-btn
            fab
            color="primary"
            @click="contributorsDialog = true"
            absolute
            top
            right
          >
            <v-icon>add</v-icon>
          </v-btn>
          <v-card-title> Contributors </v-card-title>
          <v-card-subtitle align="left">
            If you would like to help with this project, sign up as a
            contributor today!
          </v-card-subtitle>
          <v-card-text align="left">
            <br />
            <div>
              <v-avatar color="secondary" size="35">
                <span class="white--text">JD</span>
              </v-avatar>
              <span style="margin-left: 15px"> Jane Doe</span>
            </div>
            <br />
            <div>
              <v-avatar color="ng-gold" size="35">
                <span class="white--text">AS</span>
              </v-avatar>
              <span style="margin-left: 15px"> Ana Suarez</span>
            </div>
            <br />
            <div>
              <v-avatar color="ng-blue" size="35">
                <span class="white--text">PD</span>
              </v-avatar>
              <span style="margin-left: 15px"> Peter Dawson</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="4"> </v-col>
    </v-row>
    <v-dialog v-model="tasksDialog" max-width="750px"> </v-dialog>
    <v-dialog v-model="contributorsDialog" max-width="750px"> </v-dialog>
  </v-container>
</template>

<script>
import { projectsRef } from "../../../firebaseApp";

export default {
  data: () => ({
    community: {},
    progress: 30,
    project: {},
    tasksDialog: false,
    contributorsDialog: false,
  }),
  computed: {},
  methods: {},
  mounted() {
    let projectId = this.$route.params.id;
    projectsRef.on("value", (snap) => {
      snap.forEach((proj) => {
        if (proj.key == projectId) {
          let project = {};
          project = proj.val();
          project.id = proj.key;
          project.date = new Date(project.dateAdded).toLocaleDateString(
            "en-US"
          );
          this.project = project;
        }
      });
    });
  },
};
</script>